const UiCarouselPropsOption = {
  arrow: { type: String, default: "hover" },
  // 切换箭头显示时期
  delay: { type: Number, default: 3e3 },
  // 自动切换的间隔
  transitionDelay: { type: Number, default: 500 },
  // 过渡的间隔
  width: { type: [String, Number], default: "100%" },
  // 轮播图宽度, 支持10px, 10vh, 10
  height: { type: [String, Number], default: "100%" },
  // 轮播图高度, 支持10px, 10vh, 10
  drag: { type: Boolean, default: false },
  // 是否开启拖拽功能
  autoplay: { type: Boolean, default: true },
  // 是否开启自动切换
  pagination: { type: Boolean, default: true }
  // 是否开启分页器
};
const UiCarouselEmits = {
  "drag": () => true,
  "next": (_number) => true,
  "change": (_number) => true,
  "drag-after": () => true,
  "change-after": (_number) => true
};

export { UiCarouselEmits, UiCarouselPropsOption };
//# sourceMappingURL=index.mjs.map
